/**
 * i18n configuration – React-i18next with browser language detection.
 *
 * Supported languages: de (default), en, ar (RTL), tr
 * Persistence: localStorage.kp_lang
 * Auto-detect order: localStorage → navigator → fallback to 'de'
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import tr from './locales/tr.json';
import fr from './locales/fr.json';
import it from './locales/it.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
];

export const RTL_LANGUAGES = ['ar'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      ar: { translation: ar },
      tr: { translation: tr },
      fr: { translation: fr },
      it: { translation: it },
    },
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'ar', 'tr', 'fr', 'it'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'kp_lang',
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

// Apply RTL direction on <html> whenever language changes
const applyDirection = (lng) => {
  if (typeof document === 'undefined') return;
  const isRtl = RTL_LANGUAGES.includes(lng);
  document.documentElement.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lng);
};

applyDirection(i18n.language || 'de');
i18n.on('languageChanged', applyDirection);

export default i18n;
